
import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
import PageLoader from '@/app/components/loaders/PageLoader.vue';
import WorkspaceUtils from '@/app/utils/workspace-utils';
import VideoPlayer from '@/app/components/VideoPlayer.vue';
import VideoNotAvailable from '@/app/components/VideoNotAvailable.vue';
import publicClient from '@/app/clients/public-client';
import ActivityTracker from '@/app/player/models/activity-tracker';
import vueHeadful from 'vue-headful';
import GlobalUtils from '@/lib/utils/global-utils';
declare let PARTNER_MODE: boolean;
declare let PARTNER_ID: string;

@Component({
  name: 'player-link',
  components: {
    TButton,
    PageLoader,
    VideoPlayer,
    VideoNotAvailable,
    vueHeadful
  }
})
export default class LinkComponent extends Vue {
  private loaded = false;
  private partnerMode = PARTNER_MODE;
  private partnerId = PARTNER_ID;
  private linkId!: string;
  private videoList: any[] = [];
  private currentIndex = 0;
  private resourceType = '';
  private videoInAccessible = false;
  private videoInfoLoaded = false;
  private title = '';
  private isFreemiumUser = false;
  private dimension1: string | undefined = undefined;
  private errorCode = '';
  private userFeedback: any = {};
  private videoId: string | undefined = undefined;
  private fingerprint = '';
  private workspace = {
    color: '',
    name: '',
    logo: ''
  };

  mounted() {
    this.linkId = this.$route.params.linkId;
    publicClient
      .getShareableLinkInfo(this.linkId)
      .then(data => {
        this.title = data.title;
        this.workspace.color = data.workspace_brand_color;
        this.workspace.name = data.workspace_display_name;
        this.workspace.logo = data.workspace_logo_url;
        this.videoList = data.videos_summary;
        this.videoId = data.videos_summary[this.currentIndex].id;
        this.resourceType = data.resource_type;
        this.isFreemiumUser = data.freemium_user;
        if (this.resourceType == 'Collection') {
          this.dimension1 = GlobalUtils.genUuid();
        }
        if (!this.$isEmpty(this.videoList)) {
          this.videoList.forEach(video => {
            publicClient
              .getVideoInfo(this.linkId, video.id, this.$isMobile)
              .then(data => {
                this.videoInfoLoaded = true;
                Object.keys(data).forEach(key => {
                  Vue.set(video, key, data[key]);
                });
                if (this.canTrackAnalytics(data)) {
                  video.activityTracker = new ActivityTracker(
                    video.id,
                    this.linkId,
                    'video_player',
                    data.stepsInfo,
                    this.dimension1!
                  );
                }
              })
              .catch(e => {
                this.$error(e);
              });
            publicClient
              .getThumbnailUrl(this.linkId, video.id)
              .then(result => {
                if (result.url) {
                  Vue.set(video, 'url', result.url);
                }
              })
              .catch(e => {
                this.$error(e);
              });
          });
        }
        this.loaded = true;
      })
      .catch(e => {
        if (e.statusCode == 404) {
          this.videoInAccessible = true;
          this.errorCode = 'not_found';
        } else if (e.statusCode == 400 && e.errorCode == 'mau_limit_exceeded') {
          this.videoInAccessible = true;
          this.errorCode = 'mau_limit_exceeded';
        } else {
          this.$error(e);
        }
        this.loaded = true;
      });
  }

  get subscription() {
    return this.$user && this.$user.subscription;
  }

  get shareablePdfUrl() {
    return `/share/${this.$route.params.linkId}/pdf`;
  }

  satisfaction(video, satisfaction) {
    this.fingerprint = video.activityTracker.fingerprint;
    publicClient
      .updateFeedback(
        this.videoId,
        this.fingerprint,
        satisfaction,
        this.$route.params.linkId
      )
      .then(result => {
        this.userFeedback = result;
      });
  }

  fingerPrint(video) {
    return video.activityTracker && video.activityTracker.fingerPrint;
  }

  startTracker(video) {
    video.activityTracker && video.activityTracker.start();
    video.activityTracker &&
      video.activityTracker.getFeedback().then(result => {
        this.userFeedback = result;
      });
  }

  setIndex(index) {
    this.videoList[this.currentIndex].activityTracker &&
      this.videoList[this.currentIndex].activityTracker.reinitialise();
    this.currentIndex = index;
    this.videoList[this.currentIndex].activityTracker
      .getFeedback()
      .then(result => {
        this.userFeedback = result;
      });
  }

  canTrackAnalytics(data) {
    return (
      this.$route.query.skip_analytic != 'true' &&
      (data.stepsInfo ||
        ['manual_upload', 'insta'].indexOf(data.templateType) > -1)
    );
  }
}
